import { useFeatureFlag } from "@squide/firefly";
import { useCallback } from "react";
import { buildPersonPath } from "./personPath.ts";

export function usePersonPath() {
    const isNavigationRedesign = useFeatureFlag("navigation-redesign", false);

    return useCallback((personId: string, subpath?: string) => buildPersonPath(isNavigationRedesign, personId, subpath), [isNavigationRedesign]);
}
